import * as React from 'react';
import { getYear, getMonth } from 'date-fns';
import './Calendar.css';
import { Book } from '../../types/Book';
import { startOfYear, endOfYear, addMonths } from 'date-fns/esm';
import GroupOfMonths from './Week/GroupOfMonth';
import { LibraryCard } from '../../types/LibraryCard';
import CalendarHeader from './Header/Header';
import { useMediaQuery } from 'react-responsive';
import LinearProgress from '@material-ui/core/LinearProgress';
import { CardsManagerCallbacks } from '../CardsManager/CardsManager';
import { connect, useSelector } from 'react-redux';
import { getCardsByDate, CardWithDate, getCardsByDateNew } from '../../store/calendar/selectors';
import { CallbacksContext } from '../BookCalendar/BookCalendar';
import WelcomeCalendar from './Welcome/WelcomeCalendar';

export interface BookWithDates {
	startReadISO: string;
	finishReadISO: string;
	book: Book;
}

export interface BooksWithParsedDates {
	start: Date;
	finish: Date;
	book: Book;
}

interface Props {
	callbacks: CardsManagerCallbacks;
	openDate: Date;
	setDate: (date: Date) => void;
}

interface StateProps {
	cards: LibraryCard[];
}

interface Week {
	days: Date[];
	books: BooksWithParsedDates[];
}

interface CalendarProps {
	startOfYear: Date;
	endOfYear: Date;
}

export interface Month {
	startOfMonth: Date;
	cards: CardWithDate[];
}

const Calendar: React.FunctionComponent<Props> = ({ openDate, setDate, callbacks }) => {
	const [isLoading, setLoading] = React.useState(false);

	const MAX_MONTHS_IN_GROUP = useMediaQuery({ maxWidth: "600px" }) ? 1 : 4;

	const booksByYears = useSelector(getCardsByDateNew);

	const calendarProps: CalendarProps = React.useMemo(() => {
		return {
			startOfYear: startOfYear(openDate),
			endOfYear: endOfYear(openDate)
		}
	}, [openDate]);

	const monthGroup: Month[][] = [[]];

	for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
		const month = addMonths(calendarProps.startOfYear, monthIndex);

		const year = getYear(month),
			monthNumber = getMonth(month);

		if (monthGroup[monthGroup.length - 1].length < MAX_MONTHS_IN_GROUP) {
			monthGroup[monthGroup.length - 1].push({
				startOfMonth: month,
				cards: booksByYears[year] && booksByYears[year][monthNumber] ? booksByYears[year][monthNumber] : []
			});
		}
		else {
			monthGroup.push([
				{
					startOfMonth: month,
					cards: booksByYears[year] && booksByYears[year][monthNumber] ? booksByYears[year][monthNumber] : []
				}
			])
		}
	}

	return <div className="calendar">
		<CallbacksContext.Provider value={callbacks}>
			<CalendarHeader
				date={openDate}
				changeDate={(date) => setDate(date)}
				isLoading={callbacks.loading}
			/>

			{isLoading && <LinearProgress />}
			
			{
				!callbacks.loading && Object.keys(booksByYears).length === 0 && <WelcomeCalendar/>
			}

			{
				monthGroup.map((months, key) => {
					return <GroupOfMonths
						months={months}
						openDate={openDate}
						key={key}
					/>
				})
			}
		</CallbacksContext.Provider>
	</div>;
};

export default connect()(Calendar);
